import { DataService } from './DataService';
import { mapSVIJson } from './DataTransformation';
import { DATA_URL } from '../model/StaticVariables';

const stateNames = {
    10: 'Delaware',
    11: 'DistrictofColumbia',
    12: 'Florida',
    13: 'Georgia',
    15: 'Hawaii',
    16: 'Idaho',
    17: 'Illinois',
    18: 'Indiana',
    19: 'Iowa',
    20: 'Kansas',
    21: 'Kentucky',
    22: 'Louisiana',
    23: 'Maine',
    24: 'Maryland',
    25: 'Massachusetts',
    26: 'Michigan',
    27: 'Minnesota',
    28: 'Mississippi',
    29: 'Missouri',
    30: 'Montana',
    31: 'Nebraska',
    32: 'Nevada',
    33: 'NewHampshire',
    34: 'NewJersey',
    35: 'NewMexico',
    36: 'NewYork',
    37: 'NorthCarolina',
    38: 'NorthDakota',
    39: 'Ohio',
    40: 'Oklahoma',
    41: 'Oregon',
    42: 'Pennsylvania',
    44: 'RhodeIsland',
    45: 'SouthCarolina',
    46: 'SouthDakota',
    47: 'Tennessee',
    48: 'Texas',
    49: 'Utah',
    50: 'Vermont',
    51: 'Virginia',
    53: 'Washington',
    54: 'WestVirginia',
    55: 'Wisconsin',
    56: 'Wyoming',
    72: 'PuertoRico',
    '00': 'AllStates',
    '01': 'Alabama',
    '02': 'Alaska',
    '04': 'Arizona',
    '05': 'Arkansas',
    '06': 'California',
    '08': 'Colorado',
    '09': 'Connecticut'
};
class DevDataService extends DataService {
    constructor() {
        super({ _needsAuth: false, _name: 'Dev Serv' });
    }

    _api = (args) => {
        const { type, scope, tract, year = '2010', counties, theme = 0, state = { slug: '', fips: '' }, extent = { x1: 0, y1: 0, x2: 0, y2: 0 } } = args;
        const base = window.location.protocol + '//grasp_internal_test.cdc.gov/svi2021/';
        const poiBase = `https://svi.cdc.gov`;
        const slug = this.formatSlug(args);
        const baseMap_arcGIS_style_path = `${window.location.origin}${DATA_URL}/style/light-gray-labels2.json`;

        const baseMap_arcGIS_geometry_path = window.location.protocol + '//basemaps.arcgis.com/v1/arcgis/rest/services/World_Basemap/VectorTileServer/tile/{z}/{y}/{x}.pbf';
        const output = { url: '', body: {}, head: {} };
        const defaults = {
            AppVersion: 'SVIDB',
            State: 'US',
            XMin: extent.x1,
            YMin: extent.y1,
            XMax: extent.x2,
            YMax: extent.y2
        };
        switch (slug) {
            case 'geometry_state':
                output.url = `${DATA_URL}/geometry/detailed_states.json`;
                break;
            // ΔVΔVΔ: Geometry
            case 'geometry_national_county':
                let adjyear = year;
                output.url = `${DATA_URL}/geometry/national_county_${adjyear}.json`;
                break;

            case 'geometry_national_census':
                output.url = `${base}/maps/tractstopojson/tracts2010_STFIPS_${state.fips}.json`;
                output.loop = {
                    state
                };
                break;

            case 'geometry_state_county':
                if (!state.slug && state.fips) {
                    state.slug = stateNames[state.fips];
                }
                output.url = `${base}/maps/countytopojson/${state.slug}.json`;
                break;

            case 'geometry_state_census':
                output.url = `${base}/maps/tractstopojson/tracts2010_STFIPS_${state.fips}.json`;
                break;

            case 'geometry_hhs':
                output.url = `${DATA_URL}/geometry/hhs_regions.json`;
                break;

            // ΔVΔVΔ: Lists
            case 'list_county':
                output.url = `${DATA_URL}/list/allcountieslist.json`;
                break;
            case 'list_county_sm':
                output.url = `${DATA_URL}/list/smallCountieslist.json`;
                break;

            case 'list_state':
                output.url = `${DATA_URL}/list/statesList.json`;
                break;

            // ΔVΔVΔ: SVI data
            case 'svi_national_county':
            case 'svi_national_census':
            case 'svi_state_county':
            case 'svi_state_census':
                output.url = `${poiBase}/api/SVIData`;
                output.body = {
                    StateFIPS: state.fips ? state.fips : '00',
                    CountyFIPS: counties,
                    SVIYear: year,
                    SVIThemeID: theme
                };
                break;

            // ΔVΔVΔ: POI
            case 'poi_hospital':
            case 'poi_hospitals':
                output.url = `${poiBase}/api/PostGetPointsData`;
                output.body = Object.assign(defaults, {
                    LayerName: 'Hospitals',
                    PointsCount: 0,
                    key: args.tileKey
                });
                break;
            case 'poi_nursinghome':
            case 'poi_nursing_home':
            case 'poi_nursing_homes':
                output.url = `${poiBase}/api/PostGetPointsData`;
                output.body = Object.assign(defaults, {
                    LayerName: 'Nursing Homes',
                    PointsCount: 0,
                    key: args.tileKey
                });
                break;

            case 'poi_daycare':
            case 'poi_day_care_centers':
                output.url = `${poiBase}/api/PostGetPointsData`;
                output.body = Object.assign(defaults, {
                    LayerName: 'Day Care Centers',
                    PointsCount: 0,
                    key: args.tileKey
                });
                break;

            case 'poi_school':
            case 'poi_schools':
            case 'poi_public_schools':
                output.url = `${poiBase}/api/PostGetPointsData`;
                output.body = Object.assign(defaults, {
                    LayerName: 'Public Schools',
                    PointsCount: 149,
                    key: args.tileKey
                });
                break;
            // ΔVΔVΔ: Basemap
            case 'base_geometry':
                output.url = baseMap_arcGIS_geometry_path;
                break;

            case 'base_style':
                output.url = baseMap_arcGIS_style_path;
                break;
            default:
                var err = new Error('Could Not create call object config for ' + slug);
                throw err;
        }

        return output;
    };
    // ΔVΔVΔ: Use for inheritance
    applyFiltertransformData = (callObj, res) => {
        if (!res || !res.data) return [];
        if (callObj.args && callObj.args.type === 'geometry') {
            return [res.data];
        }
        if (callObj?.args?.type === 'svi') {
            return mapSVIJson(res.data);
        }
        return res.data ? res.data : [];
    };

    authenticate = async () => {
        return true;
    };
    applyAuth = (callObj) => {
        return callObj;
    };
}
export { DevDataService };
